$('.Page_our_food_ingredients_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots:false,
  infinite: false,
  centerMode: false,
  prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="34" y="34" width="34" height="34" rx="17" transform="rotate(-180 34 34)" fill="#0C3D37"/><path d="M19.8333 22.6666L14.1667 17L19.8333 11.3333" stroke="white" stroke-width="3"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="34" y="34" width="34" height="34" rx="17" transform="rotate(-180 34 34)" fill="#0C3D37"/><path d="M19.8333 22.6666L14.1667 17L19.8333 11.3333" stroke="white" stroke-width="3"/></svg></button>',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 4
      }
    }
  ]
});